import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jobsService from "./../../api/jobsService";

export const getjobSearchResults = createAsyncThunk(
  "search",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.searchJobs(payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch jobs results",
      );
    }
  },
);

export const getPersonalizedJobs = createAsyncThunk(
  "jobs/getPersonalizedJobs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await jobsService.personalizedJobs();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch personalized jobs",
      );
    }
  },
);
export const getJobFilter = createAsyncThunk("filter", async () => {
  try {
    const response = await jobsService.jobsFilter();
    if (response) {
      return {
        jobFilterItems: response?.data,
        success: "",
        error: "",
      };
    }
  } catch (error) {
    console.log("getJobFilter catch === ", error);
    return {
      jobFilterItems: {},
      success: "",
      error: error,
    };
  }
});
// export const getjobSearchResults = createAsyncThunk("search", async (payload, { rejectWithValue }) => {
//     try {
//         const response = await jobsService.searchJobs(payload)
//         return response.data
//     } catch (error) {
//         console.log(error);
//         return rejectWithValue(error.response?.data || "Failed to fetch jobs results");
//     }
// })
export const getEstimatedSalary = createAsyncThunk(
  "/estimated-salary",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.getEstimatedSalary(payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch estimated salary results",
      );
    }
  },
);

export const getJobsbyStateAndCityData = createAsyncThunk(
  "/jobs/city",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await jobsService.getJobsByStateAndCity(payload);
      return result.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data ||
          "Failed to fetch jobs by state and city results",
      );
    }
  },
);

// export const applyJob = createAsyncThunk(
//   "/jobs/apply",
//   async (id, { rejectWithValue }) => {
//     try {
//       const result = await jobsService.applyJob(id);
//       return result.data;
//     } catch (error) {
//       console.log(error);
//       return rejectWithValue(error.response?.data || "Failed to apply job");
//     }
//   },
// );
export const applyJob = createAsyncThunk(
  "/jobs/apply",
  async ({ job_id, data }, { rejectWithValue }) => {
    try {
      const result = await jobsService.applyJob({ job_id, data });
      return result.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to apply job");
    }
  },
);
export const getJobDetail = createAsyncThunk(
  "jobs/detail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await jobsService.getJobDetail(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch job detail",
      );
    }
  },
);
export const getPublicJobDetail = createAsyncThunk(
  "jobs/getPublicJobDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await jobsService.getPublicJobDetail(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch job detail",
      );
    }
  },
);
export const getSimilarJobs = createAsyncThunk(
  "jobs/getSimilarJobs",
  async ({ id, page = 1, limit = 6 }, { rejectWithValue }) => {
    try {
      const response = await jobsService.getSimilarJobs({ id, page, limit });
      return { ...response.data, page };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch similar jobs",
      );
    }
  },
);
export const jobTracking = createAsyncThunk(
  "jobs/jobTracking",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.jobTracking(payload);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const toggleBookmark = createAsyncThunk(
  "jobs/toggleBookmark",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.toggleBookmark(payload);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const checkMultipleBookmarks = createAsyncThunk(
  "jobs/checkMultipleBookmarks",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.checkMultipleBookmarks(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const checkBookmark = createAsyncThunk(
  "jobs/checkBookmark",
  async (jobId, { rejectWithValue }) => {
    try {
      const response = await jobsService.checkBookmark(jobId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getBookmarkJob = createAsyncThunk(
  "jobs/getBookmarkJob",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.getBookmarkJob(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const nurseProfile = createAsyncThunk(
  "jobs/nurseProfile",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await jobsService.nurseProfile(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch nurse Profile",
      );
    }
  },
);
export const jobStatus = createAsyncThunk(
  "jobs/jobStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await jobsService.jobStatus(payload);

      return response.data?.data || response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch job Status",
      );
    }
  },
);
export const seheduleInterview = createAsyncThunk(
  "jobs/seheduleInterview",
  async ({ applicationId, data }, { rejectWithValue }) => {
    try {
      const response = await jobsService.seheduleInterview(applicationId, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to respond interview",
      );
    }
  },
);
export const jobsDocument = createAsyncThunk(
  "jobs/jobsDocument",
  async ({ applicationId, data }, { rejectWithValue }) => {
    try {
      const response = await jobsService.jobsDocument(applicationId, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to respond interview",
      );
    }
  },
);
export const appliedJob = createAsyncThunk(
  "jobs/appliedJob",
  async (id, { rejectWithValue }) => {
    try {
      const response = await jobsService.appliedJob(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch job detail",
      );
    }
  },
);
const initialState = {
  JobsResults: [],
  JobDetail: null,
  PublicJobDetail: null,
  similarJobs: { data: [], total: 0, page: 1, pages: 1 },
  similarJobsLoading: false,
  EstimatedSalary: [],
  jobFilterItems: {},
  seheduleInterviewItems: {},
  jobsDocumentItems: {},
  appliedJobItems: {},
  documentUploading: false,
  jobStatusItems: {},
  jobTrackingItems: {},
  nurseProfileItems: {},
  toggleBookmarkItems: {},
  checkMultipleBookmarksItems: {},
  getBookmarkJobItems: {},
  savedJobIds: [],
  hasApplied: false, // Store has_applied status
  isDetailLoading: false,
  isLoading: false,
  isSuccess: false,
  bookmarkLoading: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const jobsSlice = createSlice({
  name: "jobsResults",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getjobSearchResults.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })

      .addCase(getjobSearchResults.fulfilled, (state, action) => {
        state.isLoading = false;

        if (action.payload?.success === false) {
          state.isSuccess = false;
          state.isError = true;
          state.errorMessage = action.payload?.message || "Failed to load jobs";
          return;
        }

        state.isSuccess = true;
        state.isError = false;

        const newJobs = action.payload?.data || [];
        const page = action.payload?.page || 1;

        if (page === 1) {
          state.JobsResults = {
            data: newJobs,
            total: action.payload?.total || 0,
          };
        } else {
          state.JobsResults = {
            data: [...(state.JobsResults?.data || []), ...newJobs],
            total: action.payload?.total || 0,
          };
        }

        state.successMessage =
          action.payload?.message || "Jobs retrieved successfully";

        state.errorMessage = "";
      })

      .addCase(getjobSearchResults.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getEstimatedSalary.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getEstimatedSalary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.EstimatedSalary = action.payload.EstimatedSalary || [];
        state.successMessage =
          action.payload.message || "Estimated salary Fetched Successfully";
        state.errorMessage = "";
      })
      .addCase(getEstimatedSalary.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getJobFilter.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(getJobFilter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobFilterItems = action.payload?.jobFilterItems || {};
      })

      .addCase(getJobFilter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getJobDetail.pending, (state) => {
        state.isDetailLoading = true;
        state.hasApplied = false; // Reset on new job load
      })
      .addCase(getJobDetail.fulfilled, (state, action) => {
        state.isDetailLoading = false;
        state.JobDetail = action.payload?.data || action.payload;
      })
      .addCase(getJobDetail.rejected, (state, action) => {
        state.isDetailLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getPublicJobDetail.pending, (state) => {
        state.isLoading = true;
        state.hasApplied = false; // Reset on new job load
      })
      .addCase(getPublicJobDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.PublicJobDetail = action.payload?.data || action.payload;
      })
      .addCase(getPublicJobDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(nurseProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(nurseProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.nurseProfileItems = action.payload?.data || action.payload;
      })
      .addCase(nurseProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(appliedJob.pending, (state) => {})
      .addCase(appliedJob.fulfilled, (state, action) => {
        state.appliedJobItems = action.payload?.data || action.payload;
        // Store has_applied status in Redux
        state.hasApplied = action.payload?.data?.has_applied || false;
      })
      .addCase(appliedJob.rejected, (state, action) => {
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(seheduleInterview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(seheduleInterview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.seheduleInterviewItems = action.payload?.data || action.payload;
      })
      .addCase(seheduleInterview.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(jobsDocument.pending, (state) => {
        state.documentUploading = true;
      })
      .addCase(jobsDocument.fulfilled, (state, action) => {
        state.documentUploading = false;
        state.jobsDocumentItems = action.payload?.data || action.payload;
      })
      .addCase(jobsDocument.rejected, (state, action) => {
        state.documentUploading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(jobStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(jobStatus.fulfilled, (state, action) => {
        state.isLoading = false;

        state.jobStatusItems = action.payload;
      })
      .addCase(jobStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getSimilarJobs.pending, (state) => {
        state.similarJobsLoading = true;
      })
      .addCase(getSimilarJobs.fulfilled, (state, action) => {
        state.similarJobsLoading = false;

        const payload = action.payload || {};
        // Handle both { data: [...] } and { data: { data: [...] } } shapes
        const inner = Array.isArray(payload.data)
          ? payload
          : payload.data || payload;
        const newJobs = inner.data || [];
        const page = payload.page || inner.page || 1;
        const total = inner.total ?? 0;
        const pages = inner.pages ?? inner.total_pages ?? 1;

        if (page === 1) {
          state.similarJobs = { data: newJobs, total, page, pages };
        } else {
          state.similarJobs = {
            data: [...(state.similarJobs?.data || []), ...newJobs],
            total,
            page,
            pages,
          };
        }
      })
      .addCase(getSimilarJobs.rejected, (state, action) => {
        state.similarJobsLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(jobTracking.pending, (state) => {})
      .addCase(jobTracking.fulfilled, (state, action) => {
        state.jobTrackingItems = action.payload?.data || action.payload;
      })
      .addCase(jobTracking.rejected, (state, action) => {
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getBookmarkJob.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(getBookmarkJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        // Extract jobs from bookmarks array
        const bookmarks = action.payload?.data?.bookmarks || [];
        const jobs = bookmarks.map((bookmark) => bookmark.job);

        state.getBookmarkJobItems = {
          data: jobs,
          total: action.payload?.data?.total || 0,
          page: action.payload?.data?.page || 1,
          pages: action.payload?.data?.pages || 1,
        };
      })
      .addCase(getBookmarkJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(checkMultipleBookmarks.pending, (state) => {
        state.bookmarkLoading = true;
      })
      .addCase(checkMultipleBookmarks.fulfilled, (state, action) => {
        state.bookmarkLoading = false;

        const bookmarks = action.payload?.data;

        if (Array.isArray(bookmarks)) {
          const newIds = bookmarks
            .filter((item) => item.bookmarked)
            .map((item) => item.job_id);

          state.savedJobIds = Array.from(
            new Set([...state.savedJobIds, ...newIds]),
          );
        } else if (bookmarks && typeof bookmarks === "object") {
          const newIds = Object.keys(bookmarks)
            .filter((id) => bookmarks[id])
            .map((id) => Number(id));

          state.savedJobIds = Array.from(
            new Set([...state.savedJobIds, ...newIds]),
          );
        }
      })
      // .addCase(checkMultipleBookmarks.fulfilled, (state, action) => {
      //   state.bookmarkLoading = false;

      //   const bookmarks = action.payload?.data;

      //   if (Array.isArray(bookmarks)) {
      //     state.savedJobIds = bookmarks
      //       .filter((item) => item.bookmarked)
      //       .map((item) => item.job_id);
      //   } else if (bookmarks && typeof bookmarks === "object") {
      //     state.savedJobIds = Object.keys(bookmarks)
      //       .filter((id) => bookmarks[id])
      //       .map((id) => Number(id));
      //   } else {
      //     state.savedJobIds = [];
      //   }
      // })
      .addCase(checkMultipleBookmarks.rejected, (state, action) => {
        state.bookmarkLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(toggleBookmark.pending, (state) => {
        state.bookmarkLoading = true;
      })
      .addCase(toggleBookmark.fulfilled, (state, action) => {
        state.bookmarkLoading = false;

        const jobId = action.meta.arg.job_id;
        const isBookmarked = action.payload?.data?.bookmarked;

        if (isBookmarked) {
          if (!state.savedJobIds.includes(jobId)) {
            state.savedJobIds.push(jobId);
          }
        } else {
          state.savedJobIds = state.savedJobIds.filter((id) => id !== jobId);
        }
      })

      .addCase(toggleBookmark.rejected, (state) => {
        state.bookmarkLoading = false;
      });
  },
});

export default jobsSlice.reducer;
